import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  private currentLanguage = new BehaviorSubject<string>('es');
  public translations = new BehaviorSubject<any>({});

  constructor(private http: HttpClient) {
    this.setLanguage('es'); // Default language
  }

  setLanguage(language: string) {
    this.currentLanguage.next(language);
    this.http
      .get(`/assets/i18n/${language}.json`)
      .subscribe((translations) => this.translations.next(translations));
  }

  getLanguage() {
    return this.currentLanguage.asObservable();
  }

  getTranslations() {
    return this.translations.asObservable();
  }
}
